module.exports = __webpack_public_path__ + "img/OriginWithLabel.a5732bb6.jpg";